import React, {useEffect} from 'react';
import {StyleSheet, Platform, ScrollView} from 'react-native';
import {useForm, Controller} from 'react-hook-form';
import TextInput from '../../components/TextInput';
import Error from '../../components/Error';
import Button from '../../components/Button';
import {calculCSIS} from './calcul';
import {isEmpty, isPositiveNumber} from '../../utils';

const FormCSIS = ({
  setAssietteImpot,
  setResultatFiscal,
  setMontantIMF,
  setMontantIS,
  setMontantCSIS,
  jumpTo,
}) => {
  const {register, handleSubmit, control, errors, watch} = useForm({
    mode: 'onChange',
    defaultValues: {
      produit_exploitation: 0,
      reprise_exploitation: 0,
      produit_financier: 0,
      reprise_financiere: 0,
      benefice: 0,
      deficit: 0,
      imputation_deficits_ordinaire: 0,
      imputation_deficits_ard: 0,
    },
  });

  const onSubmit = (values) => {
    const total = calculCSIS(values);
    setAssietteImpot(total.assietteImpot);
    setResultatFiscal(total.resultatFiscal);
    setMontantIMF(total.montantIMF);
    setMontantIS(total.montantIS);
    setMontantCSIS(total.montantCSIS);
    jumpTo ? jumpTo('second') : '';
  };

  const benefice = watch('benefice');

  useEffect(() => {
    register('produit_exploitation', {
      required: true,
      validate: (value) => isPositiveNumber(value),
    });
    register('reprise_exploitation', {
      required: true,
      validate: (value) => isPositiveNumber(value),
    });
    register('produit_financier', {
      required: true,
      validate: (value) => isPositiveNumber(value),
    });
    register('reprise_financiere', {
      required: true,
      validate: (value) => isPositiveNumber(value),
    });
    register('benefice', {
      validate: (value) => isPositiveNumber(value),
    });
    register('deficit');
    register('imputation_deficits_ordinaire');
    register('imputation_deficits_ard');
  }, [register]);

  return (
    <ScrollView>
      <Controller
        control={control}
        name="produit_exploitation"
        render={(props) => (
          <TextInput
            value={props.value}
            onChangeText={props.onChange}
            label="Produit d'exploitation"
            placeholder="Veuillez entrer une valeur"
            keyboardType={Platform.OS === 'ios' ? 'number-pad' : 'numeric'}
          />
        )}
      />
      {errors.produit_exploitation?.type === 'required' && (
        <Error>Ce champ est obligatoire !</Error>
      )}

      {errors.produit_exploitation?.type === 'validate' && (
        <Error>Ce champ doit être un entier positif !</Error>
      )}

      <Controller
        control={control}
        name="reprise_exploitation"
        render={(props) => (
          <TextInput
            value={props.value}
            onChangeText={props.onChange}
            label="Reprise exploitation"
            placeholder="Veuillez entrer une valeur"
            keyboardType={Platform.OS === 'ios' ? 'number-pad' : 'numeric'}
          />
        )}
      />
      {errors.reprise_exploitation?.type === 'required' && (
        <Error>Ce champ est obligatoire !</Error>
      )}

      {errors.reprise_exploitation?.type === 'validate' && (
        <Error>Ce champ doit être un entier positif !</Error>
      )}

      <Controller
        control={control}
        name="produit_financier"
        render={(props) => (
          <TextInput
            value={props.value}
            onChangeText={props.onChange}
            label="Produit financier"
            placeholder="Veuillez entrer une valeur"
            keyboardType={Platform.OS === 'ios' ? 'number-pad' : 'numeric'}
          />
        )}
      />
      {errors.produit_financier?.type === 'required' && (
        <Error>Ce champ est obligatoire !</Error>
      )}

      {errors.produit_financier?.type === 'validate' && (
        <Error>Ce champ doit être un entier positif !</Error>
      )}

      <Controller
        control={control}
        name="reprise_financiere"
        render={(props) => (
          <TextInput
            value={props.value}
            onChangeText={props.onChange}
            label="Reprise financière"
            placeholder="Veuillez entrer une valeur"
            keyboardType={Platform.OS === 'ios' ? 'number-pad' : 'numeric'}
          />
        )}
      />
      {errors.reprise_financiere?.type === 'required' && (
        <Error>Ce champ est obligatoire !</Error>
      )}

      {errors.reprise_financiere?.type === 'validate' && (
        <Error>Ce champ doit être un entier positif !</Error>
      )}

      <Controller
        control={control}
        name="benefice"
        render={(props) => (
          <TextInput
            value={props.value}
            onChangeText={props.onChange}
            label="Bénéfice"
            placeholder="Veuillez entrer une valeur"
            keyboardType={Platform.OS === 'ios' ? 'number-pad' : 'numeric'}
          />
        )}
      />
      {errors.benefice?.type === 'required' && (
        <Error>Ce champ est obligatoire !</Error>
      )}

      {errors.benefice?.type === 'validate' && (
        <Error>Ce champ doit être un entier positif !</Error>
      )}

      {isEmpty(benefice) && (
        <>
          <Controller
            control={control}
            name="deficit"
            render={(props) => (
              <TextInput
                value={props.value}
                onChangeText={props.onChange}
                label="Déficit"
                placeholder="Veuillez entrer une valeur"
                keyboardType={Platform.OS === 'ios' ? 'number-pad' : 'numeric'}
              />
            )}
            rules={{
              required: true,
              validate: (value) => isPositiveNumber(value),
            }}
          />
          {errors.deficit?.type === 'required' && (
            <Error>Ce champ est obligatoire !</Error>
          )}

          {errors.deficit?.type === 'validate' && (
            <Error>Ce champ doit être un entier positif !</Error>
          )}
        </>
      )}

      {!isEmpty(benefice) && (
        <>
          <Controller
            control={control}
            name="imputation_deficits_ordinaire"
            render={(props) => (
              <TextInput
                value={props.value}
                onChangeText={props.onChange}
                label="Imputation déficits ordinaire"
                placeholder="Veuillez entrer une valeur"
                keyboardType={Platform.OS === 'ios' ? 'number-pad' : 'numeric'}
              />
            )}
            rules={{
              validate: (value) => isPositiveNumber(value),
            }}
          />
          {errors.imputation_deficits_ordinaire?.type === 'validate' && (
            <Error>Ce champ doit être un entier positif !</Error>
          )}
        </>
      )}

      {!isEmpty(benefice) && (
        <>
          <Controller
            control={control}
            name="imputation_deficits_ard"
            render={(props) => (
              <TextInput
                value={props.value}
                onChangeText={props.onChange}
                label="Imputation déficits ARD"
                placeholder="Veuillez entrer une valeur"
                keyboardType={Platform.OS === 'ios' ? 'number-pad' : 'numeric'}
              />
            )}
            rules={{
              validate: (value) => isPositiveNumber(value),
            }}
          />
          {errors.imputation_deficits_ard?.type === 'validate' && (
            <Error>Ce champ doit être un entier positif !</Error>
          )}
        </>
      )}

      <Button onPress={handleSubmit(onSubmit)} label="Faire la simulation" />
    </ScrollView>
  );
};

const styles = StyleSheet.create({});

export default FormCSIS;
